module.exports = __webpack_public_path__ + "static/media/IMG_6357.6ff6ce1d.jpg";